// The photos of one identity, connected (PRD-0031 slice 03). The grid under
// `components/identities/` stays pure — the fetch lives here.
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useFaceReadId } from '@/features/face-matching/hooks/useFaceMatching'
import { type IdentityPhotosPage, photosApi } from '@/services/api/photos'

/** How many thumbnails one page of the grid holds. */
export const PHOTOS_PAGE_SIZE = 20

export const identityPhotosKeys = {
  page: (caseId: string, personId: string, page: number) =>
    ['case', caseId, 'identity-photos', personId, page] as const,
}

export function useIdentityPhotos(caseId: string, personId: string | null, page = 1) {
  // The photos are the identity's face evidence: no read while AFD is off (ADR-0051).
  const readPersonId = useFaceReadId(personId)
  return useQuery<IdentityPhotosPage>({
    queryKey: identityPhotosKeys.page(caseId, readPersonId ?? '', page),
    queryFn: () =>
      photosApi.identityPhotos(caseId, readPersonId as string, {
        page,
        pageSize: PHOTOS_PAGE_SIZE,
      }),
    enabled: Boolean(caseId && readPersonId),
    // Paging keeps the previous grid on screen instead of flashing empty.
    placeholderData: keepPreviousData,
  })
}
